import * as Yup from "yup";

const resolveMessage = (message, t) =>
  typeof t === "function" ? t(message) : message;

const mapYupErrors = (error) => {
  if (!error) return {};
  if (Array.isArray(error.inner) && error.inner.length > 0) {
    return error.inner.reduce((acc, item) => {
      const path = item?.path;
      if (!path || acc[path]) return acc;
      acc[path] = item.message;
      return acc;
    }, {});
  }
  if (error.path) {
    return { [error.path]: error.message };
  }
  return {};
};

export const getCompanyStepFieldKeys = (step = 1) => {
  switch (Number(step)) {
    case 1:
      return ["companyName", "country"];
    case 2:
      return ["industry"];
    case 3:
      return ["employeesRange", "revenueRange"];
    case 4:
      return ["serviceCountries", "objectives"];
    default:
      return [];
  }
};

export const buildCompanyStepSchema = (step, t) => {
  const message = (text) => resolveMessage(text, t);
  switch (Number(step)) {
    case 1:
      return Yup.object({
        companyName: Yup.string()
          .trim()
          .required(message("Please enter your company name.")),
        country: Yup.string()
          .trim()
          .required(message("Please select a country.")),
        targetFrequency: Yup.string().oneOf(["yearly", "monthly"]),
        enableMonthlyYearlySwitch: Yup.boolean(),
        enableViewDetailsSwitch: Yup.boolean(),
        showCategoryDashboardWidgets: Yup.boolean(),
        showOnlyMetricsWithTargetAndData: Yup.boolean(),
      });
    case 2:
      return Yup.object({
        industry: Yup.string()
          .trim()
          .required(message("Please select an industry.")),
      });
    case 3:
      return Yup.object({
        employeesRange: Yup.string()
          .trim()
          .required(message("Please select an employees range.")),
        revenueRange: Yup.string()
          .trim()
          .required(message("Please select a revenue range.")),
      });
    case 4:
      return Yup.object({
        serviceCountries: Yup.array().of(Yup.string()),
        objectives: Yup.array().of(Yup.string()),
      });
    default:
      return null;
  }
};

export const buildCompanySubmitSchema = (t) => {
  const message = (text) => resolveMessage(text, t);
  return Yup.object({
    companyName: Yup.string()
      .trim()
      .required(message("Please enter your company name.")),
    country: Yup.string().trim().required(message("Please select a country.")),
    industry: Yup.string()
      .trim()
      .required(message("Please select an industry.")),
    employeesRange: Yup.string()
      .trim()
      .required(message("Please select an employees range.")),
    revenueRange: Yup.string().trim(),
    serviceCountries: Yup.array().of(Yup.string()),
    objectives: Yup.array().of(Yup.string()),
    targetFrequency: Yup.string().oneOf(["yearly", "monthly"]),
    enableMonthlyYearlySwitch: Yup.boolean(),
    enableViewDetailsSwitch: Yup.boolean(),
    showCategoryDashboardWidgets: Yup.boolean(),
    showOnlyMetricsWithTargetAndData: Yup.boolean(),
  });
};

export const validateCompanyFormStep = (step = 1, form = {}, t) => {
  const schema = buildCompanyStepSchema(step, t);
  if (!schema) return {};
  try {
    schema.validateSync(form, { abortEarly: false });
    return {};
  } catch (error) {
    return mapYupErrors(error);
  }
};

export const validateCompanySubmitForm = (form = {}, t) => {
  const schema = buildCompanySubmitSchema(t);
  try {
    schema.validateSync(form, { abortEarly: false });
    return {};
  } catch (error) {
    return mapYupErrors(error);
  }
};
